const message = {
    title: '',
    message: {
        typeMessage: '',
        messageBody: {
            number: '',
        },
    },
    sendDate: '',
    errorCount: 0,
    from: 'Janoo',
    to: '',
    ref: null,
    refId: null,
    placeId: 1
}

const customer_user_created = {
    scheduled_msg_title: 'Associado: Novo usuário criado!',
    messageModel: `Olá *{0}*, \nSeus dados foram enviados para a instituição *{1}*.\n\nEnviaremos novidades da avaliação de seu cadastro!`
}

const customer_activated_agent = {
    scheduled_msg_title: 'Associado: Cadastro ativado!',
    messageModel: `Parabéns *{0}*!!\n\nCadastro validado por: *{1}*`
}

const vendor_user_created = {
    scheduled_msg_title: 'Gestor: Novo usuário criado!',
    messageModel: `Olá equipe *{0}*!\n\nTemos um novo cadastro aguardando sua aprovação!\n*Nome:* {1}\n*Contato:* {2}`
}

const request_institution = {
    scheduled_msg_title: 'Instituição: Solicitação de Cadastro!',
    messageModel: `*Nova instituição para cadastro*: \n\nNome: *{0}*\nCNPJ: *{1}*\nEmail: *{2}*\nTelefone: *{3}*\nCidade: *{4}*`,
}

export default {
    message,
    customer_user_created,
    customer_activated_agent,
    vendor_user_created,
    request_institution,
}
